// Copyright (c) John Nesky and contributing authors, distributed under the MIT license, see accompanying the LICENSE.md file.


import {BOP_VERSION} from "../synth/Release.js";
import {soundPresetCategories, Preset, PresetCategory} from "./SoundPresets.js";
export {Preset, PresetCategory} from "./SoundPresets.js";

// Instead of checking the user agent string to determine whether the device is mobile,
// try checking whether the primary pointer device is "coarse" (i.e. a touchscreen).
// export const isMobile: boolean = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|android|ipad|playbook|silk/i.test(navigator.userAgent);
export const isMobile: boolean = matchMedia("(pointer:coarse)").matches;

export const isOnMac: boolean = /^Mac/i.test(navigator.platform) || /Mac OS X/i.test(navigator.userAgent) || /^(iPhone|iPad|iPod)/i.test(navigator.platform) || /(iPhone|iPad|iPod)/i.test(navigator.userAgent);
export const ctrlSymbol: string = isOnMac ? "⌘" : "Ctrl+";
export const ctrlName: string = isOnMac ? "command" : "control";

export function prettyNumber(value: number): string {
	return value.toFixed(2).replace(/\.?0*$/, "");
}

export class EditorConfig {
	public static readonly version: string = BOP_VERSION;
	
	public static readonly versionDisplayName: string = "Bop";
	public static readonly releaseNotesURL: string = "https://sahildev.com/bop/about/";
	
	public static readonly presetCategories = soundPresetCategories;

	public static valueToPreset(presetValue: number): Preset | null {
		const categoryIndex: number = presetValue >> 6;
		const presetIndex: number = presetValue & 0x3F;
		return EditorConfig.presetCategories[categoryIndex].presets[presetIndex];
	}
	
	public static midiProgramToPresetValue(program: number): number | null {
		for (let categoryIndex: number = 0; categoryIndex < EditorConfig.presetCategories.length; categoryIndex++) {
			const category: PresetCategory = EditorConfig.presetCategories[categoryIndex];
			for (let presetIndex: number = 0; presetIndex < category.presets.length; presetIndex++) {
				const preset: Preset = category.presets[presetIndex];
				if (preset.generalMidi && preset.midiProgram == program) return (categoryIndex << 6) + presetIndex;
			}
		}
		return null;
	}
	
	public static nameToPresetValue(presetName: string): number | null {
		for (let categoryIndex: number = 0; categoryIndex < EditorConfig.presetCategories.length; categoryIndex++) {
			const category: PresetCategory = EditorConfig.presetCategories[categoryIndex];
			for (let presetIndex: number = 0; presetIndex < category.presets.length; presetIndex++) {
				const preset: Preset = category.presets[presetIndex];
				if (preset.name == presetName) return (categoryIndex << 6) + presetIndex;
			}
		}
		return null;
	}
}
